export default "__VITE_ASSET__DZa08wEb__"